<div
  class="modal fade"
  bsModal
  #entryModal="bs-modal"
  [config]="{ backdrop: false }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-static-name"
>
  <div class="modal-dialog modal-sm" style="max-width: 45% !important">
    <div class="modal-content">
      <div class="modal-header">
        <h4
          id="dialog-static-name2"
          class="modal-title pull-left"
          *ngIf="commitType === 'add'"
        >
          {{ ("new" | translate) + " " + (type | translate) }}
        </h4>
        <h4
          id="dialog-static-name"
          class="modal-title pull-left"
          *ngIf="commitType === 'edit'"
        >
          {{ (type | translate) + " " + ("edit" | translate) }}
        </h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="entryModal.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form #preferenceForm="ngForm" class="mt-3" novalidate>
          <div class="col-md-12 col-sm-12">
            <div class="form-group row">
              <label for="filter_name" class="col-md-4 col-sm-12">{{
                (type | translate) + " " + ("name" | translate)
              }}</label>
              <div class="col-md-8 col-ms-12">
                <input
                  name="filter_name"
                  id="filter_name"
                  [disabled]="saveForm"
                  #filter_Name="ngModel"
                  [ngClass]="
                    filter_Name.invalid && errorShow ? 'errorInput' : ''
                  "
                  class="form-control form-control-sm"
                  [(ngModel)]="entryName"
                  required
                />
                <div
                  *ngIf="filter_Name.invalid && errorShow"
                  class="errorMessage"
                >
                  {{ "important_area" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="application_status"
                class="col-md-4 col-sm-12"
              ></label>
              <div class="input-group col-md-8 col-ms-12">
                <p-checkbox
                  name="application_status"
                  [disabled]="saveForm"
                  [(ngModel)]="levelStatus"
                  binary="true"
                  [label]="'valid_for_all_users' | translate"
                  styleClass="kl-checkbox"
                  id="application_status"
                ></p-checkbox>
                <p-checkbox
                  name="application_design"
                  [disabled]="saveForm"
                  [(ngModel)]="levelDesign"
                  binary="true"
                  [label]="'save_as_default' | translate"
                  styleClass="kl-checkbox"
                  id="application_design"
                ></p-checkbox>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="pull-right">
          <button
            class="btn btn-sm btn-greenish"
            [disabled]="saveForm"
            *ngIf="commitType === 'add'"
            (click)="
              preferenceForm.invalid ? (errorShow = true) : setPreference()
            "
          >
            <i
              class="fal fa-spinner fa-spin fa-fw"
              *ngIf="saveForm"
              style="font-size: 21px"
            ></i>
            {{ "save" | translate }}
          </button>
          <button
            class="btn btn-sm btn-greenish"
            [disabled]="saveForm"
            *ngIf="commitType === 'edit'"
            (click)="
              preferenceForm.invalid ? (errorShow = true) : setPreference()
            "
          >
            <i
              class="fal fa-spinner fa-spin fa-fw"
              *ngIf="saveForm"
              style="font-size: 21px"
            ></i>
            {{ "edit" | translate }}
          </button>
          <button class="btn btn-sm btn-default" (click)="hide()">
            {{ "cancel" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
